module.exports = "/images/bn.svg?9a683f7bc28aa8a787feb1bc91677c94";